import { axios, httpWithAuth } from '~/clients';
import { GET_VEHICLE_RECOMMENDATIONS } from '~/constants/endpoints';
import { blobCdnUrl, vexCdnUrl } from '~/constants/environment';
import { InventoryTypeId } from '~/constants/inventoryType';
import recommendationSource from '~/constants/recommendationSource';
import { RecommendedVehicle } from '~/contracts/vdp';
import { RecommendedPayload } from '~/services/vdp/contracts';

type VehicleFromRecommendations = Omit<
  RecommendedVehicle,
  'imageUrl' | 'isFavorited' | 'vehicleUnlockDateTime'
> & {
  imageUrl?: string;
  vehicleUnlockDateTime: string;
};

export default async function fetchRecommendations(
  payload: RecommendedPayload,
  isLoggedIn: boolean,
  controller: AbortController
): Promise<RecommendedVehicle[]> {
  const fetcher = isLoggedIn ? httpWithAuth : axios;

  const data = await fetcher.post<{
    source: typeof recommendationSource;
    vehicles: VehicleFromRecommendations[];
  }>(GET_VEHICLE_RECOMMENDATIONS, payload, { signal: controller.signal });

  return data.data.vehicles.map(
    (vehicle: VehicleFromRecommendations): RecommendedVehicle => ({
      ...vehicle,
      imageUrl:
        vehicle.imageUrl == null ||
        vehicle.vehicleInventoryType === InventoryTypeId.DealerMarketplace
          ? `${vexCdnUrl}/${vehicle.stockNumber}/hero.jpg`
          : `${blobCdnUrl}${vehicle.imageUrl}`,
      isFavorited: false
    })
  );
}
